import React from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import styles from "./LabResults.module.css";

/**
 * Bảng chỉ số xét nghiệm theo nhóm, dựng theo LabResultsView của màn
 * CateMedicalExaminationDetail bên mobile.
 *
 * Dữ liệu từ WareHouseDetailDto.xetNghiem: mỗi dòng là một chỉ số kèm giá trị,
 * đơn vị, khoảng tham chiếu và cờ bất thường do backend tính sẵn.
 */

const DIRECTION = {
  UP: { Icon: FaArrowUp, className: styles.dirUp, label: "Cao hơn ngưỡng" },
  DOWN: {
    Icon: FaArrowDown,
    className: styles.dirDown,
    label: "Thấp hơn ngưỡng",
  },
};

const LabResults = ({
  results = [],
  performedAt,
  emptyText = "Không có thông tin xét nghiệm.",
}) => {
  if (results.length === 0) {
    return <div className={styles.empty}>{emptyText}</div>;
  }

  // Gom theo tenNhom, giữ nguyên thứ tự backend trả về.
  const groups = results.reduce((acc, item) => {
    const name = item.tenNhom || "KHÁC";
    (acc[name] = acc[name] || []).push(item);
    return acc;
  }, {});

  return (
    <div className={styles.wrap}>
      {performedAt && (
        <div className={styles.performedAt}>Ngày thực hiện: {performedAt}</div>
      )}

      {Object.keys(groups).map((groupName) => (
        <div key={groupName} className={styles.group}>
          <div className={styles.groupName}>{groupName}</div>

          <div className={styles.tableWrap}>
            <table className={styles.table}>
              {/* Cố định bề rộng 3 cột số liệu để các nhóm thẳng hàng nhau;
                  cột "Chỉ số" nhận phần còn lại và tự xuống dòng khi tên dài. */}
              <colgroup>
                <col />
                <col className={styles.colResult} />
                <col className={styles.colUnit} />
                <col className={styles.colRef} />
              </colgroup>
              <thead>
                <tr>
                  <th>Chỉ số</th>
                  <th className={styles.center}>Kết quả</th>
                  <th className={styles.center}>Đơn vị</th>
                  <th className={styles.center}>Tham chiếu</th>
                </tr>
              </thead>
              <tbody>
                {groups[groupName].map((row, i) => {
                  const dir = DIRECTION[row.chieuLech];
                  return (
                    <tr
                      key={`${row.maChiSo || row.tenChiSo}-${i}`}
                      className={row.batThuong ? styles.rowAbnormal : ""}
                    >
                      <td>{row.tenChiSo || row.maChiSo}</td>
                      <td
                        className={`${styles.center} ${
                          row.batThuong ? styles.valueAbnormal : ""
                        }`}
                      >
                        <span className={styles.valueCell}>
                          {row.giaTri}
                          {dir && (
                            <dir.Icon
                              className={dir.className}
                              title={dir.label}
                              aria-label={dir.label}
                            />
                          )}
                        </span>
                      </td>
                      <td className={`${styles.center} ${styles.muted}`}>
                        {row.donVi}
                      </td>
                      <td className={`${styles.center} ${styles.muted}`}>
                        {row.khoangThamChieu}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LabResults;
